// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-edit{clear:both;display:block;margin-bottom:15px}", "",{"version":3,"sources":["webpack://./resources/js/components/pages/EditServiceProvider/style.scss"],"names":[],"mappings":"AAAA,aAGE,UAAA,CADA,aAAA,CADA,kBAEA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
